import React, { Component } from 'react'
import { useQuery } from 'react-query'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import moment from 'moment'
import axios from 'axios';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance';
import S3FileUpload from 'react-s3';
import swal from '@sweetalert/with-react';
export default class ViewCertificateDecCommittee extends Component {
    constructor(props) {
        super(props)
        this.state = {
            //   orgCode : props.match.params.orgcode,
            //   stage2cdcturl: "",

            reportOfreviewProcess: {
                orgCode: props.match.params.orgcode,
                stage2cdcturl: "",

            },
            data: {},
            config: {
                bucketName: process.env.REACT_APP_BUCKET_NAME,
                dirName: process.env.REACT_APP_DIR_NAME /* optional */,
                region: process.env.REACT_APP_REGION,
                accessKeyId: process.env.REACT_APP_ACCESS_ID,
                secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
            },
            buttonStatus: "none",
            downloadbuttonStatus: "none",
            uploadDocumentStatus: "none",
            uploadedDocumentStatus: "none",
            showFile: "Image",
            uploadedProcessUrl: "",
            submitStatus: true,
            messageforvalidation: "none",
            editStatus: "none",
            isLoading:false
        }
        this.viewprocessUrlInput = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        return { id: props.match.params.orgcode || 0 };
    }
    componentDidMount() {
      const api = APIURL + '/api/stagetwo/get/stagetwodata/' + this.state.reportOfreviewProcess.orgCode
        axios.get(api, {headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
         }})
        .then(res => {
                console.log("data ", res.data.response)
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response });
                    if (this.state.data.stage2cdcturl) {
                        var uplodedFileName = this.state.data.stage2cdcturl.split("/")
                        var uplodedFileNameToView = uplodedFileName[4]
                        this.setState({ uploadedProcessUrl: this.state.data.stage2cdcturl })
                        this.setState({ uploadDocumentStatus: "none", uploadedDocumentStatus: "block", downloadbuttonStatus: "none", showFileNameToview: uplodedFileNameToView, editStatus: "none" })
                    }
                    else if (!this.state.data.stage2cdcturl) {
                        this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", downloadbuttonStatus: "block", editStatus: "block" })
                    }

                }
            })
            .catch(e => {
                console.log("Something went Wrong", e)
                var string = JSON.stringify(e).split("/")[0]
                const regex = /401/g;
                const found = string.match(regex);
    
                console.log("found", found);
                if (found !== null) {
                    window.location.href = "/signin"
                   // alert("if")
                    this.setState({isLoading:true})
                }
            })
    }
    handleprocessreview = (event) => {
        event.preventDefault();
        let newArr = this.viewprocessUrlInput.current.files[0];
        this.handleUpload(newArr);
    }
    handleUpload = (file) => {
        if (file.size <= 131950) {
            S3FileUpload
                .uploadFile(file, this.state.config)
                .then(data => {
                    console.log("data s3", data)
                    var tempData = this.state.reportOfreviewProcess;
                    tempData.stage2cdcturl = data.location
                    var file = data.key.split("/")
                    var fileName = file[1];
                    var docType = this.checkFileExtension(data.location)
                    this.setState({
                        stage2cdcturl: tempData,
                        showFile: docType, submitStatus: false,
                        filenameToview: fileName,
                        messageforvalidation: "none",
                        fileToUpload: data.location
                    });
                })
                .catch(err => console.error(err))
        }
        else {
            this.setState({ filenameToview: "", messageforvalidation: "block" })

        }
    };

    checkFileExtension = (file) => {
        if (file) {
            if (file.match(/\.(jpg|jpeg|png|gif)$/)) {
                return "Image"
            } else if (file.match(/\.(pdf)$/)) {
                return 'pdf'
            }
        }
    }

    removeDoc = () => {
        var tempData = this.state.reportOfreviewProcess;
        tempData.stage2cdcturl = ""
        this.setState({ reportOfreviewProcess: tempData, submitStatus: true });
    }
    removeUplodedDoc = () => {
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    this.setState({ uploadDocumentStatus: "block", uploadedDocumentStatus: "none", uploadProcessUrl: "", submitStatus: true, editStatus: "block" })

                }
            })
    }

    handleRoute = () => {
        window.location.href = "/" + localStorage.getItem("role") + '/certificatedeccommittee/' + this.state.reportOfreviewProcess.orgCode;
    }

    generateReviewProcess = () => {
        return axios.get(APIURL + '/api/generatepdf/get/cdcreport/' + this.state.reportOfreviewProcess.orgCode, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }
        )
            .then((response) => {
                const blob = new Blob(
                    [response.data],
                    { type: 'application/pdf' }
                )
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = this.state.reportOfreviewProcess.orgCode + '- CDC Deliberation & Decision' + `.pdf`
                link.click()
            })


    }

    postData = () => {
        var jsonRequest = {
            orgCode: this.state.reportOfreviewProcess.orgCode,
            stage2cdcturl: this.state.reportOfreviewProcess.stage2cdcturl,
        }
        console.log("json", jsonRequest)
        axios.patch(APIURL + "/api/stagetwo/patch/stage2cdcturl", jsonRequest)
            .then((res) => {
                if (res.data.errorCode === 0) {
                    ToastInstance('Success', 'CDC Updated')
                }
                else {
                    ToastInstance('Error', 'Something Went Wrong')
                }
            })
            .catch(err => {
                ToastInstance('warning', 'Something Went Wrong..Please Try again')
            })

    }
    downloadSignedPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.uploadedProcessUrl
        window.open(link)


    }

    downloadUploadPdf = () => {
        const link = document.createElement('a');
        console.log("link", link)
        link.href = this.state.fileToUpload
        window.open(link)
    }
    render() {
        const FileReviewProcess = () => (
            this.state.showFile === 'Image' ?
                <>
                    <img className="img-fluid" src={this.state.reportOfreviewProcess.stage2cdcturl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadUploadPdf()} />
                    {
                        localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                            ""
                            :
                            <span>
                                <h6 onClick={() => this.removeUplodedDoc('stage2cdcturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }} ><i className="fas fa-times"></i></h6>
                            </span>
                    }


                </>
                :
                this.state.showFile === 'pdf' ?
                    <div className="row">
                        <img className="img-fluid" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadUploadPdf()} />
                        {
                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                ""
                                :
                                <span>
                                    <h6 onClick={() => this.removeUplodedDoc('stage2cdcturl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                </span>
                        }

                        <div className="row">
                            <span>{this.state.filenameToview}</span>

                        </div>
                    </div>
                    :
                    <>
                        <input type='file' ref={this.processUrlInput} onChange={this.handleprocessreview} />
                        <p style={{ fontSize: '10px', color: 'red' }}>Only Pdf and images are accpeted</p>
                    </>
        )
        if(this.state.isLoading){
            return(<h1>Loading</h1>)
        }
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "4rem", paddingTop: "1rem", paddingRight: "6rem" }}>
                                        <div className="row">
                                            <div className="col-sm-12">

                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Name of the Organization</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.orgName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Legal name</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.legalname}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">CDC Member</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.cdcmember}</p>
                                                    </div>



                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">NACE Code</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.nabcbcodeName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Date</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofaudit).format("DD-MMM-YYYY")}</p>
                                                    </div>


                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Type</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.typeofaudit}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Reference No</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.refno}</p>
                                                    </div>


                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Standard</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.standard}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Man-days</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.mandaysPlanned}</p>
                                                    </div>



                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Lead Auditor</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.teamleaderName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Technical expert</label>
                                                    <div className="col-sm-3">
                                                        <p>{
                                                        
                                                            this.state.data.technicalExpertName === null ?
                                                        
                                                            "NA" :
                                                            this.state.data.technicalExpertName

                                                    }</p>
                                                    </div>



                                                    {/* <label htmlFor="staticEmail" className="col-sm-3 labelsize">Auditor</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.auditorOneName}</p>
                                                    </div> */}


                                                </div>
                                                <hr />
                                                <div className="row headingcolor">
                                                    <div className="col-sm-6 text-dark mt-1">
                                                        <h5>Audit Findings</h5>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-8 labelsize">All activities are found satisfactory  Completed </label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.allactfoundsat}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-8 labelsize">Certification Criteria have been met</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.certificationcriteria}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-8 labelsize">Adequate Justifications for LA’s Recommendations</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.adejustification}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Document Review Comments</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.docreview === null ? "-" : this.state.data.docreview}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row">
                                                    <table className="table table-bordered">
                                                        <thead className="table-primary">
                                                            <tr>
                                                                <th>#</th>
                                                                <th scope="col" className="text-center">System Review</th>
                                                                <th scope="col" className="text-center">Review</th>
                                                                <th scope="col" className="text-center">Comments/Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr >
                                                                <td className="text-center" >1</td>
                                                                <td>Application Review</td>
                                                                <td className="text-center">{this.state.data.sysreview1}</td>
                                                                <td>{this.state.data.sysreviewremark1}</td>
                                                            </tr>
                                                            <tr >
                                                                <td className="text-center" >2</td>
                                                                <td>Contract Agreement</td>
                                                                <td className="text-center">{this.state.data.sysreview2}</td>
                                                                <td>{this.state.data.sysreviewremark2}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >3</td>
                                                                <td>Audit Team Selection</td>
                                                                <td className="text-center">{this.state.data.sysreview3}</td>
                                                                <td>{this.state.data.sysreviewremark3} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >4</td>
                                                                <td>Audit Mandays calculation</td>
                                                                <td className="text-center">{this.state.data.sysreview4}</td>
                                                                <td>{this.state.data.sysreviewremark4} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >5</td>
                                                                <td>Stage 1 Audit Report</td>
                                                                <td className="text-center">{this.state.data.sysreview5}</td>
                                                                <td>{this.state.data.sysreviewremark5}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >6</td>
                                                                <td>Stage 2/ Recertification Audit Report</td>
                                                                <td className="text-center">{this.state.data.sysreview6}</td>
                                                                <td>{this.state.data.sysreviewremark6}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >7</td>
                                                                <td>NC Report &Closure evidence (if any) </td>
                                                                <td className="text-center">{this.state.data.sysreview7}</td>
                                                                <td>{this.state.data.sysreviewremark7}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >8</td>
                                                                <td>Legal Document of Client </td>
                                                                <td className="text-center">{this.state.data.sysreview8}</td>
                                                                <td>{this.state.data.sysreviewremark8} </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Review Done By / Date</label>
                                                    <div className="col-sm-4">
                                                        <p>{moment(this.state.data.reviewbydate).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row">
                                                    <table className="table table-bordered">
                                                        <thead className="table-primary">
                                                            <tr>
                                                                <th>#</th>
                                                                <th scope="col" className="text-center">Technical Review</th>
                                                                <th scope="col" className="text-center">Review</th>
                                                                <th scope="col" className="text-center">Comments/Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr >
                                                                <td className="text-center" >1</td>
                                                                <td>Scope Statement against ANZSIC code</td>
                                                                <td className="text-center">{this.state.data.techreview1}</td>
                                                                <td>{this.state.data.techreviewremark1}</td>
                                                            </tr>
                                                            <tr >
                                                                <td className="text-center" >2</td>
                                                                <td>Exclusion and Justification adequate</td>
                                                                <td className="text-center">{this.state.data.techreview2}</td>
                                                                <td>{this.state.data.techreviewremark2}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >3</td>
                                                                <td>Has Auditor covered all the applicable Clauses (Stage 1 & Stage 2 Audit)</td>
                                                                <td className="text-center">{this.state.data.techreview3}</td>
                                                                <td>{this.state.data.techreviewremark3}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >4</td>
                                                                <td>Evidences are appropriate </td>
                                                                <td className="text-center">{this.state.data.techreview4}</td>
                                                                <td>{this.state.data.techreviewremark4} </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >5</td>
                                                                <td>NC statement and its clause ref.</td>
                                                                <td className="text-center">{this.state.data.techreview5}</td>
                                                                <td>{this.state.data.techreviewremark5}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >6</td>
                                                                <td>Verification of Corrective actions and Evidence</td>
                                                                <td className="text-center">{this.state.data.techreview6}</td>
                                                                <td>{this.state.data.techreviewremark6}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-center" >7</td>
                                                                <td>Client Acceptance of Stage 2 Audit Report</td>
                                                                <td className="text-center">{this.state.data.techreview7}</td>
                                                                <td>{this.state.data.techreviewremark7}</td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Review Done By / Date</label>
                                                    <div className="col-sm-9">
                                                        <p>{moment(this.state.data.reviewbydate1).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">CDC Review Comments</label>
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.cdcreviewcomments === null ? "-" : this.state.data.cdcreviewcomments}</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row headingcolor">
                                                    <div className="col-sm-6 text-dark mt-1">
                                                        <h5>For Recertification</h5>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-12 labelsize">Review of the system during certification tenure and complaints received if any from the customer of the certified client or any other sources</label>
                                                    <div className="col-sm-12">
                                                        <p>{this.state.data.reviewsysduringcert ===  null ? "-" : this.state.data.reviewsysduringcert }</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certification Decision</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.certificatedec}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    {/* <label htmlFor="staticEmail" className="col-sm-3 labelsize">SIGNATURE OF CDC MEMBER</label>
                                                            <div className="col-sm-3">
                                                             <p>{this.state.data.signcdcmem}</p>
                                                            </div> */}
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of CDC decision</label>
                                                    <div className="col-sm-3">
                                                        <p>{
                                                            this.state.data.dateofcdcdecision=== null ?
                                                            "-"
                                                            :
                                                           moment(this.state.data.dateofcdcdecision).format("DD-MMM-YYYY")
                                                      
                                                        }</p>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row headingcolor">
                                                    <div className="col-sm-6 text-dark mt-1">
                                                        <h5>For Office Use</h5>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">File No</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.flatno}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Certificate No</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.certificateno}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Initial Certification Date</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.initialcertdate).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date of Issue</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.dateofissue).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Expiry date</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.expirydate).format("DD-MMM-YYYY")}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Accreditation Reference</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.accreditationref === null ? "-" : this.state.data.accreditationref}</p>
                                                    </div>

                                                </div>
                                                <div className="row mt-4">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Action if any</label>
                                                    <div className="col-sm-3">
                                                        <p>{this.state.data.actionifany === null ? "-" : this.state.data.actionifany}</p>
                                                    </div>
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Date</label>
                                                    <div className="col-sm-3">
                                                        <p>{moment(this.state.data.officeusedate).format("DD-MMM-YYYY")}</p>
                                                    </div>

                                                </div>

                                                <div >
                                                    <div className="row mt-4">
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Download CDC Report</h5>
                                                        </div>
                                                        <div className="col-sm-5 mb-2" style={{ textAlign: "right" }}>
                                                            <button className="btn btn-primary col-sm-4" onClick={() => this.generateReviewProcess()}>Download</button>
                                                        </div>
                                                        <hr />

                                                    </div>
                                                </div>
                                                {
                                                    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                        ""
                                                        :
                                                        <div style={{ display: this.state.uploadDocumentStatus }}>
                                                            <div className="row mt-4">
                                                                <hr className="mt-4" />
                                                                <div className="col-sm-6 text-dark ">
                                                                    <h5>Upload CDC Report</h5>
                                                                </div>
                                                                <hr />



                                                                <div className="row mt-5" >
                                                                    <div className="col-sm-4"><label htmlFor="staticEmail" className="labelsize">Upload CDC Report </label></div>
                                                                    <div className="col-sm-6">
                                                                        <p style={{ color: "red", display: this.state.messageforvalidation }}>Please Select Size Which is less than 3 MB</p>
                                                                        {
                                                                            this.state.reportOfreviewProcess.stage2cdcturl !== "" ?
                                                                                <FileReviewProcess />
                                                                                :
                                                                                <>
                                                                                    <input type='file' ref={this.viewprocessUrlInput} onChange={this.handleprocessreview} />
                                                                                    <br></br>

                                                                                </>
                                                                        }

                                                                    </div>
                                                                    <div className="col-sm-10" />
                                                                    <button type="button" className="btn btn-sm btn-success col-sm-2" onClick={() => this.postData()} disabled={this.state.submitStatus}>Upload</button>


                                                                </div>
                                                            </div>


                                                        </div>
                                                }

                                                <div style={{ display: this.state.uploadedDocumentStatus }} >
                                                    <div className="row mt-5" >
                                                        <hr className="mt-4" />
                                                        <div className="col-sm-6 text-dark ">
                                                            <h5>Uploaded CDC Report</h5>
                                                        </div>
                                                        <hr />
                                                        <div className="col-sm-4">

                                                            <label className="mt-4 labelsize">
                                                                Uploaded CDC Report
                                                            </label>

                                                        </div>
                                                        <div className="col-sm-6">


                                                            {
                                                                this.state.uploadedProcessUrl.match(/\.(jpg|jpeg|png|gif)$/) ?
                                                                    <>
                                                                        <img className="img-fluid" src={this.state.uploadedProcessUrl} style={{ width: '80px', height: '80px' }} onClick={() => this.downloadSignedPdf()} />

                                                                        {
                                                                            localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                ""
                                                                                :
                                                                                <span>
                                                                                    <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                </span>
                                                                        }
                                                                        <p>{this.state.showFileNameToview}</p>

                                                                    </>
                                                                    :
                                                                    this.state.uploadedProcessUrl.match(/\.(pdf)$/) ?
                                                                        <>
                                                                            <img className="img-fluid mt-3" src="/dist/img/pdf.png" style={{ width: '60px', height: '60px' }} onClick={() => this.downloadSignedPdf()} />

                                                                            {
                                                                                localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?
                                                                                    ""
                                                                                    :
                                                                                    <span>
                                                                                        <h6 onClick={() => this.removeUplodedDoc('processUrl')} style={{ position: "relative", top: "-65px", marginLeft: "69px" }}><i className="fas fa-times"></i></h6>
                                                                                    </span>
                                                                            }
                                                                            <p>{this.state.showFileNameToview}</p>
                                                                        </>

                                                                        :
                                                                        ""
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    localStorage.getItem("userRole") === 'Management' || localStorage.getItem("userRole") === 'Accounts' ?

                                                        !this.state.uploadedProcessUrl ?
                                                            <>


                                                                <div className="col-sm-6">The Signed Pdf is not yet uploaded</div>

                                                            </>

                                                            :
                                                            ""
                                                        :
                                                        ""

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="card-footer">
                    {
                        localStorage.getItem("userRole") === "Management" || localStorage.getItem("userRole") === "Accounts" ?
                            ""
                            :
                            <div className="row">
                                <div className="col-lg-11"></div>
                                <div className="col-lg-1" style={{ marginBottom: "10PX" }}>

                                    <button type="submit" className="btn btn-primary" onClick={() => this.handleRoute()} style={{ display: this.state.editStatus }}>Edit</button>

                                </div>
                            </div>
                    }
                </div>
            </div>
        )
    }
}